/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used on the DAM integrations screen.
 */
export const DAM_INTEGRATIONS_DATA_IDS = {
  actionAddIntegration: `Button: Add DAM integration`,
  actionAddIntegrationCancel: `Add DAM integration: Cancel action`,
  actionAddIntegrationConfirm: `Add DAM integration: Confirm action`,
  damIntegrationListButton: `DAM integration list button: Navigate to integration`,
  emptyState: `DAM integration list: No integrations`,
  name: `Form field: Friendly name`,
  successToast: `Toast: DAM integration added`,
  type: `Form field: DAM type selection`,
};

/**
 * The form field ids used on the DAM integrations screen.
 */
export const DAM_INTEGRATIONS_FORM_IDS = {
  name: `name`,
  type: `type`,
};
